import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import AppNavbar from "@/components/common/AppNavbar";
import Sidebar from "@/components/layout/Sidebar";

export default function MasterLayout() {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      if (mobile) {
        setSidebarExpanded(false);
      }
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const toggleSidebar = () => {
    setSidebarExpanded(!sidebarExpanded);
  };

  const closeSidebar = () => {
    if (isMobile) {
      setSidebarExpanded(false);
    }
  };

  return (
    <>
      <AppNavbar onSidebarToggle={toggleSidebar} />
      <div className="flex min-h-screen">
        <Sidebar
          isExpanded={sidebarExpanded}
          isMobile={isMobile}
          onLinkClick={closeSidebar}
          onToggle={toggleSidebar}
        />
        {/* Overlay for mobile/tablet */}
        {isMobile && sidebarExpanded && (
          <div
            className="fixed inset-0 z-20 bg-black/50 transition-opacity duration-300"
            onClick={closeSidebar}
          />
        )}
        <main
          className={`w-full flex-1 transition-all duration-300 ease-in-out ${
            isMobile
              ? "ml-0 pt-32"
              : sidebarExpanded
                ? "ml-64 pt-16"
                : "ml-16 pt-16"
          } `}
        >
          <div className="p-3 sm:p-4 md:p-6 lg:p-8">
            <Outlet />
          </div>
        </main>
      </div>
    </>
  );
}
